export default {
  'streaming-games-top': {
    apiUrl: '/api/v1/intelligence_pc/streamingExcel',
    bubbleText:
      'dbi_info_download_tip',
    translate: true,
    formList: [
      {
        label: 'dbi_platform',
        type: 'checkboxGroup',
        field: 'platform',
        // defaultValue: ['twitch', 'ytg', 'facebook'],
        defaultValue: [],
        options: [
          { label: 'dbi_streaming_twitch', value: 'twitch' },
          { label: 'dbi_streaming_youtube', value: 'ytg' },
          { label: 'dbi_streaming_facebook_gaming', value: 'facebook' },
        ],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['hoursWatched', 'peackCCV', 'avgCCV', 'airtime'],
        options: [
          { label: 'Hours Watched', value: 'hoursWatched' },
          { label: 'Peak CCV', value: 'peackCCV' },
          { label: 'Avg CCV', value: 'avgCCV' },
          { label: 'Airtime', value: 'airtime' }
        ],
      },
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: 'basic_info',
        defaultValue: {
          company_show: false,
          genre_show: false,
          release_date_show: false,
          game_type_show: false,
        },
        options: [
          { label: 'dbi_label_company_info', value: 'company_show' },
          { label: 'dbi_label_genre', value: 'genre_show' },
          { label: 'dbi_release_date', value: 'release_date_show' },
          { label: 'dbi_company_game_type', value: 'game_type_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message: '',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_platform_settings',
            type: 'radio',
            field: 'platform_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_platform', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_anchors_settings',
            type: 'radio',
            field: 'influencers_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_show_top_influencers', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
  'streaming-anchors-more': {
    apiUrl: '/api/v1/intelligence_pc/kolExcel',
    bubbleText:
      'dbi_info_download_tip',
    translate: true,
    formList: [
      {
        label: 'dbi_platform',
        type: 'checkboxGroup',
        field: 'platform',
        // defaultValue: ['twitch', 'ytg', 'facebook'],
        defaultValue: [],
        options: [
          { label: 'dbi_streaming_twitch', value: 'twitch' },
          { label: 'dbi_streaming_youtube', value: 'ytg' },
          { label: 'dbi_streaming_facebook_gaming', value: 'facebook' },
        ],
      },
      {
        label: 'dbi_label_metrics',
        type: 'checkboxGroup',
        field: 'download_metrics',
        defaultValue: ['hoursWatched', 'peackCCV', 'avgCCV', 'airtime'],
        options: [
          { label: 'Hours Watched', value: 'hoursWatched' },
          { label: 'Peak CCV', value: 'peackCCV' },
          { label: 'Avg CCV', value: 'avgCCV' },
          { label: 'Airtime', value: 'airtime' }
        ],
      },
      {
        label: 'dbi_label_basic_info',
        type: 'checkbox',
        field: 'basic_info',
        defaultValue: {
          lang_region_show: true,
          url_show: true,
        },
        options: [
          { label: 'dbi_streaming_language_country', value: 'lang_region_show' },
          { label: 'dbi_streaming_channel_url', value: 'url_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_edition_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'edition_method',
            options: [{ label: 'dbi_label_aggregated', value: 'aggregated' }],
          },
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            message: '',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_game_settings',
            type: 'radio',
            field: 'game_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_games', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
};
